import { render, staticRenderFns } from "./o-site-footer.vue?vue&type=template&id=fd7f49ba"
import script from "./o-site-footer.vue?vue&type=script&lang=js"
export * from "./o-site-footer.vue?vue&type=script&lang=js"
import style0 from "./o-site-footer.vue?vue&type=style&index=0&id=fd7f49ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports